import { useSyncExternalStore } from 'react';

/**
 * 지금 나가 있는 **조회** 요청 수 — 화면 가운데 로딩 카드(`components/LoadingOverlay.tsx`)가 읽는다.
 *
 * 왜 전역 한 곳인가 (2026-09-17 사용자 요청 — "불러온다는 메시지가 잘 안 보인다")
 *   예전 표시는 화면마다 표 안쪽의 회색 `불러오는 중…` 한 줄(17곳)이었다. 표 머리 옆 작은 글씨라
 *   빈 표를 "자료가 없다"로 읽기 쉬웠다. 데이터는 **전부 `lib/api.ts` 의 `call()` 하나를 지나므로**
 *   거기서 세면 화면 17곳을 고치지 않고 전 화면에 한 번에 걸린다(새 화면도 저절로).
 *
 * ⚠️ **워밍 호출은 세지 않는다**(`silent`). 로그인하자마자 20개가 나가는데 그걸 세면 사람이
 *    아무것도 안 눌렀는데 로딩 카드가 몇 초씩 떠 있다.
 */
let inflight = 0;
const listeners = new Set<() => void>();

function emit() {
  for (const l of listeners) l();
}

/** 조회 하나를 센다. 끝나면 반드시 돌려준 함수를 부른다(성공·실패 무관). */
export function beginLoad(): () => void {
  inflight += 1;
  emit();
  let done = false;
  return () => {
    if (done) return; // 두 번 불러도 한 번만 뺀다 — 음수가 되면 카드가 영영 안 뜬다.
    done = true;
    inflight -= 1;
    emit();
  };
}

function subscribe(l: () => void) {
  listeners.add(l);
  return () => listeners.delete(l);
}

export function useInflight(): number {
  return useSyncExternalStore(subscribe, () => inflight);
}
